module.exports = __webpack_public_path__ + "img/kommune-1923.a33c57a3.svg";